import { combineReducers } from 'redux';
import commonReducer from "../slices/commonSlice";
import eventReducer from '../slices/eventSlice';
import authReducer from "../slices/authSlices";
import ticketReducer from '../slices/ticketSlice';

const rootReducer = combineReducers({
    common:commonReducer,
    event:eventReducer,
    auth:authReducer,
    tickets:ticketReducer
  });

  export default rootReducer;
